import { CapacityGranularity, CapacitySort, Filter, Id } from "@planzone/dto";
import { State } from "./types";

function matchRequest(
  state: State,
  resourceId: Id,
  from: string,
  to: string,
  granularity: CapacityGranularity,
  filter: Filter | undefined,
  sort: CapacitySort | undefined,
  size: number,
): number {
  return state.findIndex(
    (req) =>
      req.resourceId === resourceId &&
      req.from === from &&
      req.to === to &&
      req.granularity === granularity &&
      req.sort === sort &&
      req.size === size &&
      JSON.stringify(req.filter || {}) === JSON.stringify(filter || {}),
  );
}

export { matchRequest };
